import { DefaultResponseWithData } from "./system";

/** Matches GPMetals.Core.Entities.EngineCondition. */
export enum QuoteEngineCondition {
  NoFault = 0,
  MinorFault = 1,
  MajorFault = 2,
}

/** Matches GPMetals.Core.Entities.BodyCondition. */
export enum QuoteBodyCondition {
  Good = 0,
  Average = 1,
  HeavyDamage = 2,
}

/** Matches GPMetals.Core.Entities.QuoteType: which part of the widget's pricing won. */
export enum QuotePriceType {
  ScrapExport = 0,
  Salvage = 1,
  SmartPrice = 2,
}

/** Matches GPMetals.Core.Models.Lead.QuoteCalculator.QuoteAcceptedAs. */
export enum QuoteAcceptedAs {
  Collection = 1,
  DropOff = 2,
}

export interface IQuoteCalculatorAvailability {
  enabled: boolean;
  reason: string | null;
}

export interface ICalculateQuoteRequest {
  vrm: string;
  postcode: string;
  engineCondition: QuoteEngineCondition;
  bodyCondition: QuoteBodyCondition;
  alloyWheels: boolean;
  /** 0 lets the widget use the mileage it holds for the vehicle. */
  mileage: number;
  voucherCode?: string;
}

/** A priced quote. A null price means the customer offers no such option for that postcode. */
export interface ICalculatedQuote {
  quoteId: string;
  vrm: string;
  make: string;
  model: string;
  year: number;
  mileage: number;
  engineCondition: QuoteEngineCondition;
  bodyCondition: QuoteBodyCondition;
  alloyWheels: boolean;
  priceCollected: number | null;
  collectedType: QuotePriceType | null;
  priceDropOff: number | null;
  dropOffType: QuotePriceType | null;
}

export interface IQuoteLeadContact {
  contactId?: string;
  fullname?: string;
  telephone1?: string;
  telephone2?: string;
  email?: string;
  line1?: string;
  town?: string;
  postcode?: string;
}

/** Matches GPMetals.Core.Models.Lead.QuoteCalculator.QuoteLeadCreateAs. */
export enum QuoteLeadCreateAs {
  /** Seller said yes: a lead (booking for a call centre) in Awaiting Contact. */
  Lead = 0,
  /** Seller still deciding: a quote on the call list. */
  Quote = 1,
}

export interface ICreateLeadFromQuoteRequest {
  acceptedAs: QuoteAcceptedAs;
  createAs: QuoteLeadCreateAs;
  contact: IQuoteLeadContact;
  officeNotes?: string;
}

export interface ICancelQuoteLeadRequest {
  reason?: string;
}

export type IQuoteCalculatorAvailabilityResponse = DefaultResponseWithData<IQuoteCalculatorAvailability>;
export type ICalculatedQuoteResponse = DefaultResponseWithData<ICalculatedQuote>;
